<template>
  <v-container fluid class="container">
    <div v-if="corteAbierto === 3">
      <Spinner />
    </div>
    <v-row v-if="corteAbierto === 0">
      <v-col cols="12">
        <v-dialog v-model="dialogCaja" width="500" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="success"
              elevation="2"
              outlined
              class="float-right"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left> mdi-point-of-sale </v-icon>
              Abrir caja
            </v-btn>
          </template>

          <v-card>
            <v-card-title
              class="text-h6 text-weingth-bold white lighten-2 text-primary"
            >
              Apertura de caja
            </v-card-title>

            <div class="d-flex ml-5 mr-5">
              <span>Usuario: {{ sesion?.name }}</span>
              <v-spacer></v-spacer>
              <span
                >Hora:
                {{
                  fecha.getHours() +
                  ":" +
                  (fecha.getMinutes() > 9
                    ? fecha.getMinutes()
                    : "0" + fecha.getMinutes())
                }}</span
              >
            </div>

            <div class="cajas">
              <div class="cabeza">Caja</div>
              <div class="cuerpo">
                <p>Ingresa efectivo en caja</p>
                <div>
                  <v-img
                    contain
                    class="mt-1 mx-3"
                    src="@/assets/imgs/puntoVenta/calculadora icon.svg"
                    height="30px"
                  ></v-img>
                  <v-text-field
                    v-model="inicioCorte"
                    placeholder="$0.00"
                    outlined
                    type="number"
                    dense
                  ></v-text-field>
                </div>
              </div>
            </div>

            <v-card-actions>
              <div class="d-flex">
                <v-btn color="success" text block @click="closeDialogCaja">
                  Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="success"
                  @click="abrirCaja()"
                  block
                  :disabled="inicioCorte == null"
                >
                  Continuar
                </v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col class="12">
        <v-card class="completo">
          <div class="centro">
            <v-img src="@/assets/imgs/puntoVenta/cajaCerrada.svg" width="70" />
            <p class="mt-3">
              No se ha realizado apertura de caja, Por el momento no se puede
              mostrar punto de venta.
            </p>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="corteAbierto === 1 || corteAbierto === 2">
      <v-col>
        <div class="pa-2">
          <h4 class="text-primary text-left">Generar orden de venta</h4>
          <v-row>
            <v-col md="4" cols="8" class="pa-3 order-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar servicios/refacciones"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12" class="order-md-2 order-2">
              <div class="d-flex">
                <b class="mt-3">Categoría:</b>
                <div
                  class="botonVentas"
                  :class="{ activo: filtro == 1 }"
                  @click="filtrar(1)"
                >
                  Servicios
                </div>
                <div
                  class="botonVentas"
                  :class="{ activo: filtro == 2 }"
                  @click="filtrar(2)"
                >
                  Refacciones
                </div>
                <div
                  class="botonVentas"
                  :class="{ activo: filtro == 3 }"
                  @click="filtrar(3)"
                >
                  Todo
                </div>
                <div
                  class="botonVentas"
                  :class="{ activo: filtro == 4 }"
                  @click="filtrar(4)"
                >
                  Compra
                </div>
              </div>
            </v-col>
            <CierreCaja
              v-if="corteAbierto != 2"
              @cerrarCorte="cerrarCorte"
              :sesion="sesion"
            />
          </v-row>
          <v-row class="pa-0">
            <v-col cols="12" sm="6">
              <v-data-table
                v-model="data_venta.value"
                @input="calcularTotales"
                :headers="headersProductos"
                :items="items"
                :search="search"
                :single-select="singleSelect"
                item-key="_id"
                show-select
                :loading="loading"
                class="elevation-1"
              >
                <!-- group-by="Tipo" -->
                <template v-slot:header.data-table-select> </template>
              </v-data-table>
            </v-col>
            <v-col cols="12" sm="6">
              <!-- <v-select
                v-model="value"
                :items="items"
                filled
                chips
                dense
                label="Refacciones"
                multiple
                item-text="nombre"
                return-object
                ></v-select> -->
              <div class="punteado" style="text-align: left">
                <span v-if="showCancelarVenta" style="display: flex; justify-content: end;"><i id="cerrar-general" class="icon-tachita-negra" @click="cancelarVenta"></i></span>
                <div v-if="orden && orden?.client" class="mb-2">
                  <b>Orden de Servicio:</b><span> {{ orden.order }}</span
                  ><br />
                  <b>Cliente:</b
                  ><span>
                    {{
                      orden.client?.name +
                      " " +
                      orden.client?.first_lastname +
                      " " +
                      (orden.client?.second_lastname || "")
                    }}</span
                  ><br />
                  <b>Vehículo:</b
                  ><span>
                    {{
                      `${orden?.vehicle?.model?.name || ""} ${
                        orden?.vehicle?.year || ""
                      }`
                    }}</span
                  ><br />
                  <b>Servicios de la orden:</b>
                  <ul>
                    <li v-for="service in orden.services" :key="service._id">
                      {{ service?.service?.name }}
                    </li>
                  </ul>
                </div>
                <div v-else class="mb-2"><b>Venta:</b> PÚBLICO EN GENERAL</div>

                <v-divider></v-divider>
                <div class="sale-container">
                  <ul>
                    <div
                      v-if="data_venta.value.length < 1"
                      class="flex-wrap pa-2 d-flex flex-column justify-content-center align-center"
                    >
                      <v-img
                        src="@/assets/imgs/puntoVenta/no hay productos iocn.svg"
                        width="70"
                      />
                      <b class="text-center"
                        >No tiene productos y/o servicios agregados en esta
                        venta</b
                      >
                    </div>

                    <li
                      v-for="(v, index) in data_venta.value"
                      :key="v.id"
                      class="pa-2 carrito"
                    >
                      <v-text-field
                        v-model="v.quantity"
                        @input="handleInput(index, v)"
                        @blur="handleBlurSale(index, v)"
                        class="editarCantidad"
                        :class="{
                          'ml-n8': v.Tipo == 'PRODUCTOS',
                          'mr-1': v.Tipo != 'PRODUCTOS',
                        }"
                        :disabled="v.Tipo != 'PRODUCTOS'"
                        type="number"
                      >
                        <v-icon
                          slot="prepend"
                          color="red"
                          class="button-counter"
                          @click="menos(index, v)"
                          v-if="v.Tipo == 'PRODUCTOS'"
                        >
                          mdi-minus
                        </v-icon>
                        <v-icon
                          slot="append"
                          color="green"
                          class="button-counter"
                          @click="mas(index, v)"
                          v-if="v.Tipo == 'PRODUCTOS'"
                        >
                          mdi-plus
                        </v-icon>
                      </v-text-field>

                      <div class="articulo mt-1">
                        {{ `${v?.name}  (${v?.stock || 1})` }}
                      </div>
                      <div class="relative">
                        <v-text-field
                          class="editarPrecio"
                          :disabled="v.disabled"
                          v-model="v.sale_price"
                          @input="calcularTotales"
                          type="number"
                        >
                          <v-icon
                            slot="prepend"
                            :color="v.disabled ? 'gray' : 'green'"
                          >
                            mdi-currency-usd
                          </v-icon>
                        </v-text-field>
                        <v-icon
                          small
                          class="mr-2 editarPrecioIcon"
                          v-if="v.Tipo != 'PRODUCTOS'"
                          @click="v.disabled = !v.disabled"
                        >
                          mdi-pencil
                        </v-icon>
                      </div>
                      <!-- <span class="flex-grow-1 ml-3">{{ v.quantity }}</span> -->
                      <div class="totales mt-1">
                        {{ getCostoArticulo( v.quantity * v.sale_price ) }}
                        <v-icon class="delete-item" @click="handleDelete(v)"
                          >mdi-delete
                        </v-icon>
                      </div>

                      <!-- <v-input
                      
                      v-if="v.Tipo != 'PRODUCTOS'"
                      >Editar
                    </v-input> -->
                    </li>
                  </ul>
                </div>
                <v-divider></v-divider>
                <v-select
                  v-model="data_venta.paymentType"
                  :items="pagos"
                  item-text="name"
                  item-value="_id"
                  label="Tipo de pago"
                  class="ma-2"
                  @input="handleSelectFormaPago"
                ></v-select>
                <div v-if="esEfectivo" class="monto-efectivo" style="display: flex;justify-content: space-between; align-items: center;">
                      <div class="icon-text"><v-icon style="font-size: 30px; color: #2c3e50;">mdi-cash</v-icon><span>Efectivo</span></div>
                        <CustomMoney
                          :customStyle="{ marginTop: '0px' }"
                          v-model="montoIngresado"
                          :options="moneyOptions"
                        ></CustomMoney>
                </div>
                <v-textarea
                  @blur="editarNota"
                  v-if="orden && orden?.client"
                  v-model="data_venta.orden.nota_final"
                  label="Nota final"
                >
                </v-textarea>
                <span v-else></span>
                <div class="check-container">
                  <label @click="handleCheck" class="label"
                    ><b>Agregar Concepto</b></label
                  >
                  <div class="check-co">
                    <input
                      class="check"
                      type="checkbox"
                      v-model="showConcept"
                    />
                  </div>
                </div>
                <v-textarea
                  :rows="2"
                  v-if="showConcept"
                  v-model="data_venta.concepto"
                  label="Concepto de facturación"
                >
                </v-textarea>
                <div class="totaldeCompra">
                  <div class="d-flex justify-end">
                    <b>Subtotal:</b>
                    <!-- <div>$ {{ data_venta.subtotal.toFixed(2) }}</div> -->
                    <div>{{ getSubtotal( data_venta.subtotal ) }}</div>
                    <br />
                  </div>
                  <div class="d-flex justify-end">
                    <b>I.V.A.:</b>
                    <div>{{ getIVA( data_venta.iva ) }}</div>
                    <br />
                  </div>
                  <div class="d-flex justify-end">
                    <b>Total:</b>
                    <div>{{ getTotal( data_venta.total ) }}</div>
                  </div>
                  <div v-if="esEfectivo" class="d-flex justify-end">
                    <b>Cambio:</b>
                    <div>{{ getCambio( data_venta.total ) }}</div>
                  </div>

                  <venta :data_venta="data_venta" />
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <ModalCierrePv
      v-if="corteAbierto === 2"
      @cerrarCorte="cerrarCorte"
      :sesion="sesion"
    />
    <ModalRealizarCompra v-if="realizarCompra" @cerrar="cerrarCompra" @cerrarConServicio="cerrarConServicio" @exitoCompra="exitoCompra"></ModalRealizarCompra>
  </v-container>
</template>

<style scoped>
.visible {
  z-index: 300;
}
.sale-container {
  max-height: 350px;
  overflow: scroll;
  cursor: all-scroll;
}

.check-container {
  display: flex;
  align-items: center;
}

.check {
  height: 15px;
  width: 15px;
  cursor: pointer;
  color: #ccc;
}

.check-co {
  order: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 35px;
  height: 35px;
}

.label {
  order: 2;
  cursor: pointer;
  padding: 5px;
  padding-left: 2px;
}
.check-co:hover {
  background-color: #ccc;
}
.check:hover {
  min-width: 100px;
}
.delete-item {
  color: #ea1f1f;
  height: 30px;
  width: 30px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 3px;

  background-color: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

.cajas {
  border-radius: 4px;
  border-color: #f3f3f3;
  margin: 15px;
  box-shadow: 0px 3px 6px #00000029;
}
.cabeza {
  border-radius: 4px 4px 0 0;
  background-color: #f3f3f3;
  padding: 8px;
}
.cuerpo {
  display: flex;
  flex-direction: row;
  border-radius: 0 0 4px 4px;
  border-color: #f3f3f3;
  justify-content: flex-start;
  align-items: center;
  padding: 15px;
}
.cuerpo.caja {
  flex-direction: column;
}
.cuerpo .row {
  width: 100%;
}
.cuerpo div {
  display: flex;
  flex-direction: row;
}

.box {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  padding: 10px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.text-h6 {
  color: #0a4f9c;
  font-weight: bold !important;
  font-size: 20px !important;
}
.v-card__subtitle {
  text-align: left;
  margin-top: 5px;
}
.centro {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 40%;
  position: relative;
}
.completo {
  height: 80vh;
}
.punteado {
  box-shadow: 0px 3px 6px #00000029;
  border: 1px dashed #afafaf;
  border-radius: 4px;
  padding: 1.2rem;
}
.punteado hr {
  border: 1px dashed #afafaf;
  border-radius: 4px;
}
.botonVentas {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #afafaf;
  border-radius: 4px;
  color: #afafaf;
  width: 140px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 7px;
  cursor: pointer;
}
.botonVentas.activo {
  background-color: #edf6fd;
  border-color: #0a4f9c;
  color: #0a4f9c;
}

.botonVentas:hover {
  background-color: #edf6fd;
  border-color: #0a4f9c;
  color: #0a4f9c;
}
.text-verde {
  color: #4caf50;
}
.text-rojo {
  color: #ea1f1f;
}
.icon-text {
  font-size: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.icon-tachita-negra {
  width: 20px;
  height: 20px;
  background-image: url("../../assets/imgs/cerrar.svg");
  display: flex;
  align-self: center;
}
</style>
<script>
import ApiService from "../../services/apis";
import Venta from "../pages/Venta";
import Spinner from "../Loaders/spinner.vue";
import ModalCierrePv from "../Modales/ModalCierrePv.vue";
import CierreCaja from "../Modales/CierreCaja.vue";
import ModalRealizarCompra from "../Modales/ModalCompra.vue"
import Swal from "sweetalert2";
import monedaMixin from "../../mixins/moneda.js";
import CustomMoney from '../general/Form/CustomMoney.vue'
import currency from 'currency.js';

export default {
  name: "PuntoDeVenta",
  data() {
    return {
      montoIngresado: 0,
      cambio: 0,
      realizarCompra: false,
      orden: {},
      showConcept: false,
      concept: "",
      data_venta: {
        orden: { nota_final: "" },
        subtotal: 0,
        iva: 0,
        total: 0,
        value: [],
        paymentType: null,
        concepto: "",
        montoingresado: 0,
        cambio: 0,
        pagoEfectivo: false,
        ventaValida: false,
        formaPago: '',
      },
      singleSelect: false,
      corteAbierto: 3,
      dialogCaja: false,
      dialogCorte: false,
      inicioCorte: null,
      efectivoCorte: "0",
      tarjetaCorte: "0",
      transferenciaCorte: "0",
      arqueo: null,
      paso: 1,
      fecha: new Date(),
      filtro: 3,
      anterior: null,
      items: [],
      pagos: null,
      sesion: JSON.parse(sessionStorage.getItem("sesion")),
      headersProductos: [
        {
          text: "Servicio/Refacción",
          value: "name",
        },
        {
          text: "Marca",
          value: "brand.name",
        },
        {
          text: "Proveedor",
          value: "provider.company_name",
        },
        {
          text: "Precio",
          value: "sale_price",
        },
        {
          text: "cod. barras",
          value: "code_bar",
          align: " d-none",
        },
        {
          text: "Descripcion",
          value: "description",
          align: " d-none",
        },
      ],
      search: "",
      loading: false,
      moneyOptions: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      esEfectivo: false,
      showCancelarVenta: false,
    };
  },
  components: {
    Venta,
    Spinner,
    ModalCierrePv,
    CierreCaja,
    ModalRealizarCompra,
    CustomMoney
  },
  // props: {
  //   orden: {},
  // },
  created() {
    this.$bus.$off("limpiarVenta");
    this.$bus.$on("limpiarVenta", async () => {
      // console.log("bus limpiarVenta");
      this.initialize();
      this.data_venta.value = [];
      this.orden = null;
      this.data_venta.orden = null;

      // this.data_venta= { orden: {}, subtotal: 0, iva: 0, total: 0, value: [] }
    });
    // this.$bus.$off("obtenerOrden");
    // this.$bus.$on("obtenerOrden", (orden) => {
    //   this.orden = orden;
    // });
  },
  mounted() {
    this.initialize();
  },
  methods: {
    closeDialogCaja(){
      this.inicioCorte = null;
      this.dialogCaja = false
    },
    handleCheck() {
      this.showConcept = !this.showConcept;
    },
    cerrarCorte(value) {
      this.corteAbierto = value;
    },
    async initialize() {
      await this.productosYServicios();
      const routeOrder = this.$route.params.orden !== undefined ? this.$route.params.orden : false;
      const routeOrderClienteId = routeOrder ? this.$route.params?.orden?.client?._id : null;
      const jsonStringOrdenRecuperada = sessionStorage.getItem('orden');
      let ordenRecuperada = jsonStringOrdenRecuperada ? JSON.parse(jsonStringOrdenRecuperada) : null;

      if (routeOrderClienteId && (routeOrder && routeOrderClienteId !== ordenRecuperada?.client?._id)) {
        this.orden = routeOrder;
        this.data_venta.orden = this.orden;
        const jsonStringOrden = JSON.stringify(this.orden);
        sessionStorage.setItem('orden', jsonStringOrden);
        this.showCancelarVenta = true;
      } else if (ordenRecuperada) {
        this.orden = ordenRecuperada;
        this.data_venta.orden = this.orden;
      } else {
        this.orden = false;
        this.data_venta.orden = this.orden;
      }

      const jsonStringRecuperado = sessionStorage.getItem('datosVenta');
      let ventaRecuperada = jsonStringRecuperado ? JSON.parse(jsonStringRecuperado) : [];

      if (Array.isArray(ventaRecuperada) && ventaRecuperada.length > 0) {
        this.recuperarVenta(ventaRecuperada);
      }

      if ((ordenRecuperada && ordenRecuperada !== false) || (Array.isArray(ventaRecuperada) && ventaRecuperada.length > 0)) {
        this.showCancelarVenta = true;
      }

      this.tipos_pagos();
      this.disponibilidadCaja();
    },
    handleDelete(item) {
      const { _id } = item;
      this.data_venta.value = this.data_venta.value.filter(
        (itemList) => itemList._id !== _id
      );
    },
    handleInput(index, item) {
      if (Number(this.data_venta.value[index].quantity) >= item.stock) {
        this.data_venta.value[index].quantity = item.stock;
      }
      this.calcularTotales();
    },
    handleBlurSale(index, item) {
      if (Number(item.quantity) <= 1) {
        this.data_venta.value[index].quantity = 1;
        this.calcularTotales();
      }
    },
    // handleDisableProduct(){

    // },
    async productosYServicios(filtro) {
      let filters;
      if (filtro != null) {
        filters = {
          name: {
            $options: "i",
            $regex: this.search,
          },
          branch: this.sesion.employee.branch._id,
          Tipo: filtro,
        };
      } else {
        filters = {
          name: {
            $options: "i",
            $regex: this.search,
          },
          branch: this.sesion.employee.branch._id,
        };
      }
      this.loading = true;
      await ApiService.productosYServicios(filters).then((items) => {
        this.items = items.data.map((obj) => {
          return { ...obj, disabled: true };
        });
        this.loading = false;
        // this.items = items.data;
      });
    },
    menos(index, item) {
      this.data_venta.value[index].quantity =
        item.quantity > 1 ? item.quantity - 1 : 1;

      this.calcularTotales();
    },
    mas(index, item) {
      if (Number(this.data_venta.value[index].quantity) < item.stock) {
        this.data_venta.value[index].quantity =
          item.quantity >= 1 && item.Tipo == "PRODUCTOS"
            ? item.quantity + 1
            : 1;
        this.calcularTotales();
      }
    },
    calcularTotales() {
      this.data_venta.subtotal = 0;
      this.data_venta.iva = 0;
      this.data_venta.total = 0;
      this.data_venta.value.map((x) => {
        this.data_venta.subtotal += x.quantity * x.sale_price;
        this.data_venta.iva = this.data_venta.subtotal * 0.16;
        this.data_venta.total = this.data_venta.subtotal + this.data_venta.iva;
      });

      const arregloVenta = this.data_venta.value.map((item) => ({_id: item._id, quantity: item.quantity, price: item.sale_price})); // genero el arreglo de ids para enviar al selector del punto de venta

      // Convertir el arreglo de objetos a una cadena de texto JSON
      const jsonString = JSON.stringify(arregloVenta);

      // Guardar la cadena de texto JSON en sessionStorage
      sessionStorage.setItem('datosVenta', jsonString);
    },
    tipos_pagos() {
      ApiService.tipo_pagos().then((items) => {
        this.pagos = items;
        this.data_venta.paymentType = this.pagos[0]._id;
        this.handleSelectFormaPago(this.data_venta.paymentType)
      });
    },
    editarNota() {
      let orden = {
        nota_final: this.data_venta.orden.nota_final,
      };
      ApiService.ordenEditar(this.orden._id, orden);
    },
    filtrar(filtro) {
      this.realizarCompra = false;
      if (filtro === this.filtro) return;
      if (filtro == 1) {
        this.productosYServicios("SERVICIOS");
        this.filtro = 1;
      } else if (filtro == 2) {
        this.productosYServicios("PRODUCTOS");
        this.filtro = 2;
      } else if (filtro == 3) {
        this.productosYServicios();
        this.filtro = 3;
      } else {
        this.realizarCompra = true;
      }
      this.anterior = this.filtro;
    },
    async abrirCaja() {
      this.loading = true
      let abrir = {
        saleBoxId: 0,
        user: this.sesion._id,
        inBoxStart: this.inicioCorte,
      };
      try {
        this.loading = true
        await ApiService.abrirCaja(abrir);
        this.loading = false
        this.inicioCorte = null;
        this.dialogCaja = false;
        this.corteAbierto = 1;
      } catch (error) {
        this.loading = false
        return error;
      }
    },
    async disponibilidadCaja() {
      try {
        const { data } = await ApiService.cajaAbierta(this.sesion._id, 0);
        this.corteAbierto = data;
      } catch (error) {
        return error;
      }
    },
    async cerrarCompra() {
      this.realizarCompra = false;
    },
    async cerrarConServicio(arregloAux) {
      this.realizarCompra = false
      await this.productosYServicios();
      this.marcarElementoPorId(arregloAux)
    },
    marcarElementoPorId(arregloAux) {
      arregloAux.forEach((_id) => {
        // Verificar si el _id ya está presente en data_venta.value
        const index = this.data_venta.value.findIndex((item) => item._id === _id);
        if (index === -1) {
          // Si el _id no está en data_venta.value se agrega con 1
          const itemToAdd = this.items.find((item) => item._id === _id);
          if (itemToAdd) {
            itemToAdd.quantity = 1; // Cantidad inicial en 1
            this.data_venta.value.push(itemToAdd);
          }
        } else {
          // Si el _id ya está en data_venta.value, se suma
          const existingItem = this.data_venta.value[index];
          const updatedItem = { ...existingItem };
          updatedItem.quantity++;
          updatedItem.sale_price = this.items.find(item => item._id === _id).sale_price; // Actualizar el precio
          updatedItem.stock = this.items.find(item => item._id === _id).stock; // Actualizar existencia
          
          this.$set(this.data_venta.value, index, updatedItem);
        }
      });
    },
    async exitoCompra(arregloAux) {
      this.realizarCompra = false;
      Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `La compra se generó con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
      await this.productosYServicios();
      this.marcarElementoPorId(arregloAux)
    },
    getCostoArticulo(total) {
      return "$" + monedaMixin.formatPrice(total);
    },
    getSubtotal(subtotal) {
      return "$" + monedaMixin.formatPrice(subtotal);
    },
    getIVA(iva) {
      return "$" + monedaMixin.formatPrice(iva);
    },
    getTotal(total) {
      return "$" + monedaMixin.formatPrice(total);
    },
    getCambio(total) {
      if(this.esEfectivo) {
        let totalAux = currency(monedaMixin.formatPrice(total))
        let diferencia = this.montoIngresado
        let cambioAux = this.montoIngresado == 0 ? 0 : currency(diferencia).subtract(totalAux).value;
        cambioAux = cambioAux < 0 ? 0 : cambioAux
        currency(diferencia).subtract(totalAux).value < 0 ? this.data_venta.ventaValida = false : this.data_venta.ventaValida = true
        this.cambio = cambioAux
      } else {
        this.montoIngresado = 0
        this.cambio = 0
        this.data_venta.ventaValida = true
      }
      this.data_venta.montoingresado = this.montoIngresado
      this.data_venta.cambio = this.cambio
      return `$${monedaMixin.formatPrice(this.cambio)}`
    },
    handleSelectFormaPago(selectedItem) {
      let pagoSeleccionado = this.pagos.find(pago => pago._id === selectedItem)
      pagoSeleccionado.name.trim().toLowerCase() == 'efectivo' ? this.esEfectivo = true : this.esEfectivo = false;
      this.data_venta.formaPago = pagoSeleccionado.name
      this.data_venta.pagoEfectivo = this.esEfectivo
      this.getCambio(0)
    },
    recuperarVenta(arregloAux) {
      arregloAux.forEach(({ _id, quantity, price }) => {
        const index = this.data_venta.value.findIndex((item) => item._id === _id);
        if (index === -1) {
          const itemToAdd = this.items.find((item) => item._id === _id);
          if (itemToAdd) {
            itemToAdd.quantity = quantity;
            itemToAdd.sale_price = price;
            this.data_venta.value.push(itemToAdd);
          }
        } else {
          const existingItem = this.data_venta.value[index];
          const updatedItem = { ...existingItem };
          updatedItem.quantity++;
          updatedItem.sale_price = this.items.find(item => item._id === _id).sale_price;
          updatedItem.stock = this.items.find(item => item._id === _id).stock;
          
          this.$set(this.data_venta.value, index, updatedItem);
        }
      });
      this.calcularTotales();
    },
    cancelarVenta() {
      sessionStorage.removeItem('orden');
      sessionStorage.removeItem('datosVenta');
      this.orden = false;
      this.data_venta.orden = null;
      this.data_venta.value = []
      this.showCancelarVenta = false
    }
   },
  watch: {
    paso(value) {
      if (value == 0) this.inicioCorte = null;
    },
  },
};
</script>
